import { render, staticRenderFns } from "./CartaPage.vue?vue&type=template&id=1bb2caa3"
import script from "./CartaPage.js?vue&type=script&lang=js&external"
export * from "./CartaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports